import { useMemo } from 'react'

import { useMenuContext } from 'context/menu-context'

export const useSectionNav = (
  title: string | undefined,
  alignment: ScrollLogicalPosition = 'center'
) => {
  const { chapters, scrollToElement } = useMenuContext()
  const [thisSection, previousSection, nextSection] = useMemo(() => {
    const flatSections = chapters.map(c => c.sections).flat()
    const index = flatSections.findIndex(s => s.title === title)
    return [
      flatSections[index],
      flatSections[index - 1],
      flatSections[index + 1],
    ]
  }, [chapters, title])

  const scrollTo = (
    section: { element: HTMLElement } | undefined,
    alignment: ScrollLogicalPosition
  ) => {
    if (section) {
      scrollToElement(section?.element, alignment)
    }
  }

  const handlePrevClick = () => {
    const scrollToElement: [typeof thisSection, ScrollLogicalPosition] =
      thisSection?.isActive
        ? [previousSection, 'center']
        : [thisSection, alignment]
    scrollTo(...scrollToElement)
  }

  const handleNextClick = () => {
    const scrollToElement: [typeof thisSection, ScrollLogicalPosition] =
      thisSection?.isActive ? [nextSection, 'center'] : [thisSection, alignment]
    scrollTo(...scrollToElement)
  }

  return { thisSection, handlePrevClick, handleNextClick }
}
